<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 652 652"
    style="enable-background: new 0 0 652 652"
    xml:space="preserve"
    height="130"
  >
    <path
      class="st0"
      d="M126.7,250.6c-37.3-5.7-67.1,17.7-81,51.7C6.2,399.1,178.1,383.6,206,318.1C216.8,290,153.1,254.6,126.7,250.6"
    />
    <path
      class="st1"
      d="M100.7,371.1c-41.6,0-74.8-20.3-55-68.8c10.2-24.9,29-44.2,53-50.4c-10-2.6-20.2-4-30.5-4.1
	c-8.5-0.1-17,1.2-25.1,4c-31.8,13-15.6,84.1,1.8,109.1c15.9,22.6,40.1,31.6,65.5,31.6c18.8-0.3,37.3-4.5,54.3-12.5
	c29.8-13.7,38.6-31.9,34.5-50.4C179.9,355.5,137.1,371.1,100.7,371.1"
    />
    <path
      class="st2"
      d="M98.7,251.9c-24,6.2-42.8,25.4-53,50.4c-19.8,48.5,13.4,68.8,55,68.8c36.4,0,79.2-15.6,98.6-41.5
	C192,296.9,144.2,263.3,98.7,251.9"
    />
    <path
      class="st3"
      d="M135.9,294.9c-5.5,0-10.7,2.3-14.4,6.4c-7.3-8-19.7-8.5-27.6-1.3c-4.1,3.7-6.4,8.9-6.4,14.4v24h10.3v-24
	c-0.1-5.1,4-9.3,9.1-9.4s9.3,4,9.4,9.1c0,0.1,0,0.2,0,0.3v24h10.3v-24c-0.1-5.1,4-9.3,9.1-9.4c5.1-0.1,9.3,4,9.4,9.1
	c0,0.1,0,0.2,0,0.3v24h10.3v-24C155.4,303.7,146.7,294.9,135.9,294.9 M82.8,280.3c-4.1,0-7.3,3.4-7.3,7.5c0,4.1,3.4,7.3,7.5,7.3
	c4,0,7.3-3.3,7.3-7.3C90.2,283.6,86.9,280.3,82.8,280.3"
    />
    <path
      class="st4"
      d="M252.6,302.4L252.6,302.4c-3.2,0-5.9,2.6-5.9,5.9c0,0,0,0,0,0v41.2h11.7v-41.2
	C258.5,305.1,255.9,302.4,252.6,302.4C252.6,302.4,252.6,302.4,252.6,302.4 M328.1,284.4l-22,45.8L284,284.4
	c-1.8-3.6-6.1-5.1-9.7-3.4c-2.5,1.2-4.1,3.8-4.1,6.5v61.8h12.4V309l18.8,40.4h9.4l18.8-40.4v40.4h12.4v-61.8c0-4-3.3-7.3-7.3-7.3
	C331.8,280.3,329.3,281.9,328.1,284.4 M394.5,299.4c-3.2,0-5.9,2.6-5.9,5.9v0.9c-3.5-5.1-9.3-8.1-15.5-8.1
	c-14.1-0.1-25.6,11.3-25.7,25.4c0,0.3,0,0.6,0,0.9c-0.4,14.1,10.7,25.9,24.8,26.3c0.3,0,0.6,0,0.9,0c6.2,0,12-3,15.5-8.1v6.8h11.7
	v-44.3C400.4,302,397.8,299.4,394.5,299.4 M373.8,340.3c-8.8,0-14.7-7.3-14.7-15.9s5.8-15.9,14.7-15.9c9.1,0,14.8,7.3,14.8,15.9
	S382.8,340.3,373.8,340.3 M451.2,304.8c-2.8-4.2-7.9-6.8-15.1-6.8c-7.5,0-13.2,2.9-16.3,8.3v-1.1c0.1-3.2-2.5-5.9-5.7-6
	c-3.2-0.1-5.9,2.5-6,5.7c0,0.1,0,0.2,0,0.2v44.2h11.7v-25.9c0-8.6,3.8-15.1,12.1-15.1c8.4,0,10.9,6.6,10.9,15.1v25.9h11.7v-29.8
	C454.4,312.8,453.7,308.6,451.2,304.8 M507.3,299.4c-3.2,0-5.9,2.6-5.9,5.9v0.9c-3.5-5.1-9.3-8.1-15.5-8.1
	c-14.1-0.1-25.6,11.3-25.7,25.4c0,0.3,0,0.6,0,0.9c-0.4,14.1,10.7,25.9,24.8,26.3c0.3,0,0.6,0,0.9,0c6.2,0,12-3,15.5-8.1v6.8h11.7
	v-44.3C513.1,302,510.5,299.4,507.3,299.4 M486.6,340.3c-8.8,0-14.7-7.3-14.7-15.9s5.8-15.9,14.7-15.9c9.1,0,14.8,7.3,14.8,15.9
	S495.6,340.3,486.6,340.3 M565.8,299.4c-3.2,0-5.9,2.6-5.9,5.9v0.9c-3.5-5.1-9.3-8.1-15.5-8.1c-14.1-0.1-25.6,11.3-25.7,25.4
	c0,0.3,0,0.6,0,0.9c-0.4,14.1,10.7,25.9,24.8,26.3c0.3,0,0.6,0,0.9,0c6.2,0,12-3,15.5-8.1v9.3c0,9.4-5.7,13.5-15.1,13.5
	c-8.5,0-12.8-4.8-13.5-10.2h-11.8c0.7,10.4,8.6,20.6,25.3,20.6c16.7,0,26.8-7.1,26.8-23.9v-46.7C571.6,302,569,299.4,565.8,299.4
	 M545.1,340.3c-8.8,0-14.7-7.3-14.7-15.9s5.8-15.9,14.7-15.9c9.1,0,14.8,7.3,14.8,15.9S554.1,340.3,545.1,340.3 M602.1,341
	c-9.5,0-13-5.8-13.2-13h35.5c0.4-2.4,0.6-4.9,0.5-7.3c0-12.5-10.1-22.6-22.6-22.6c-0.2,0-0.4,0-0.6,0c-15.8,0-24.8,11.3-24.8,26.3
	c0,13.6,8.2,26.3,25.1,26.3c12.8,0,20.9-7.8,22.5-16.3h-11.7C611.3,337.9,608.8,340.9,602.1,341 M601.5,307.8
	c7.1,0,12.1,4.4,12.1,11.4h-24.5C589.1,311.9,594.6,307.8,601.5,307.8 M252.6,280.3c-4.1,0-7.4,3.4-7.3,7.5c0,4.1,3.4,7.4,7.5,7.3
	c4,0,7.3-3.3,7.3-7.3C260,283.7,256.7,280.3,252.6,280.3"
    />
  </svg>
</template>

<style scoped lang="css">
.st0 {
  fill: #6763fb;
}
.st1 {
  fill: #47b9e7;
}
.st2 {
  fill: #1a40cd;
}
.st3 {
  fill: #ffffff;
}
.st4 {
  fill: #323e48;
}
</style>
